import Box from '@mui/material/Box';
import { useSelector } from 'react-redux';
import PaperBase from '../../../../Paper/PaperBase';
import LcElemensCards from '../../../../card/LcElemensCards';
import CurriculumElementsCards from '../../../../card/CurriculumElementsCards';
import GranularStepCard from '../../../../card/GranularStepCard';
import {
  AddWorkedExampleButton,
  UpdateWorkedExampleButton,
  DeleteWorkedExampleButton,
  AddTeachingSuggestionButton,
  UpdateTeachingSuggestionButton,
  DeleteTeachingSuggestionButton
} from '../LevelsElements/Buttons';
import IconTooltipButton from '../../../../button/IconTooltipButton';

const FormPreview = ({
  className = 'max-h-screen-modal-content overflow-auto ',
  type = 'preview',
  onElements
}) => {
  const currentCurriculum = useSelector((state) => state?.assessment?.currentCurriculum || {});
  const minMarking = currentCurriculum?.marking?.find((item) => item.minValue) || {};
  const formData = useSelector((state) => state?.lc?.form || {});
  const permissions = useSelector((state) => state?.session?.permissions?.lc || {});

  return (
    <Box className={className}>
      <div className='py-1 flex flex-col gap-1 w-full'>
        {currentCurriculum?.levels
          ?.sort((a, b) => b.position - a.position)
          .map((item) => {
            const itemData = formData?.levels ? formData?.levels[item._id] || '' : '';
            const elements = formData?.levelsElements?.find((elm) => elm.levelId === item._id);

            return (
              <div className='flex w-full gap-1' key={item._id}>
                <PaperBase
                  backgroundColor={minMarking?.secondaryColor}
                  color={minMarking?.primaryColor}
                  className='font-bold min-w-100px max-w-100px overflow-hidden'
                  children={item.name}
                />
                <GranularStepCard
                  backgroundColor={itemData ? minMarking?.primaryColor : null}
                  color={itemData ? minMarking?.secondaryColor : null}
                  step={{ definition: itemData, ...elements }}
                  actions={
                    <div className='flex gap-1'>
                      {type === 'levels-elements' &&
                        permissions?.updated?.includes('worked-examples') &&
                        onElements &&
                        itemData && (
                          <AddWorkedExampleButton
                            onClick={() =>
                              onElements('create', 'worked-example', {
                                levelId: item._id,
                                levelName: item.name
                              })
                            }
                          />
                        )}
                      {type === 'levels-elements' &&
                        permissions?.updated?.includes('teaching-suggestion') &&
                        onElements &&
                        itemData && (
                          <AddTeachingSuggestionButton
                            onClick={() =>
                              onElements('create', 'teaching-suggestion', {
                                levelId: item._id,
                                levelName: item.name
                              })
                            }
                          />
                        )}
                    </div>
                  }
                  actionsWorkedExamples={
                    type === 'levels-elements'
                      ? (example) => (
                          <>
                            <UpdateWorkedExampleButton
                              type={type}
                              onClick={() =>
                                onElements('edit', 'worked-example', {
                                  levelId: item._id,
                                  levelName: item.name,
                                  ...example
                                })
                              }
                            />
                            <DeleteWorkedExampleButton
                              type={type}
                              onClick={() =>
                                onElements('delete', 'worked-example', {
                                  levelId: item._id,
                                  levelName: item.name,
                                  ...example
                                })
                              }
                            />
                          </>
                        )
                      : (data) => (
                          <IconTooltipButton
                            title='Preview worked example'
                            icon='expand-alt'
                            onClick={(e) => {
                              e.stopPropagation();
                              onElements('preview', 'worked-example', {
                                levelId: item._id,
                                levelName: item.name,
                                ...data
                              });
                            }}
                            style={{
                              width: 24,
                              height: 24,
                              color: 'currentColor'
                            }}
                          />
                        )
                  }
                  actionsTeachingSuggestions={
                    type === 'levels-elements'
                      ? (example) => (
                          <>
                            <UpdateTeachingSuggestionButton
                              type={type}
                              onClick={() =>
                                onElements('edit', 'teaching-suggestion', {
                                  levelId: item._id,
                                  levelName: item.name,
                                  ...example
                                })
                              }
                            />
                            <DeleteTeachingSuggestionButton
                              type={type}
                              onClick={() =>
                                onElements('delete', 'teaching-suggestion', {
                                  levelId: item._id,
                                  levelName: item.name,
                                  ...example
                                })
                              }
                            />
                          </>
                        )
                      : (data) => (
                          <IconTooltipButton
                            title='Preview worked example'
                            icon='expand-alt'
                            onClick={(e) => {
                              e.stopPropagation();
                              onElements('preview', 'teaching-suggestion', {
                                levelId: item._id,
                                levelName: item.name,
                                ...data
                              });
                            }}
                            style={{
                              width: 24,
                              height: 24,
                              color: 'currentColor'
                            }}
                          />
                        )
                  }
                />
              </div>
            );
          })}
        <LcElemensCards
          currentCurriculum={currentCurriculum}
          lcs={[formData]}
          width='min-w-100px max-w-100px'
        />
        <CurriculumElementsCards
          currentCurriculum={currentCurriculum}
          lcs={[formData]}
          width='min-w-100px max-w-100px'
        />
      </div>
    </Box>
  );
};

export default FormPreview;
